import classNames from "classnames";
import {Drawer as MuiDrawer, DrawerProps as MuiDrawerProps} from "@mui/material";
// import {Svg} from "@/shared/ui/Svg";
import styles from "./Drawer.module.scss";

type Props = MuiDrawerProps & {
    hideCloseBlock?: boolean;
    fullWidth?: boolean;
};

export const Drawer = (
    {
        className,
        sx,
        classes,
        hideCloseBlock = false,
        fullWidth = false,
        children,
        onClose,
        ...otherProps
    }: Props
) => {
    // const handleClose = () => {
    //     onClose?.({}, "backdropClick");
    // };

    return (
        <MuiDrawer
            {...otherProps}
            className={classNames(styles.drawer, {[styles.fullWidth]: fullWidth}, className)}
            sx={{
                zIndex: "var(--base-drawer-z-index)",
                ...sx,
            }}
            classes={{
                ...classes,
                paper: classNames(styles.paper, classes?.paper),
            }}
            onClose={onClose}
        >
            {/*{!hideCloseBlock && (*/}
            {/*    <div className={styles.crossContainer} onClick={handleClose}>*/}
            {/*        <Svg id={`cross`} className={styles.crossIcon} />*/}
            {/*    </div>*/}
            {/*)}*/}
            {children}
        </MuiDrawer>
    );
}
